import { useTranslation } from 'react-i18next'
import { diffConfigs } from '../../../../utils/receivingConfig'

const Scalar = ({ from, to }) => (
  <span className="inline-flex items-center gap-1 flex-wrap text-sm">
    <span className="text-red-500 line-through">{from == null ? '-' : String(from)}</span>
    <span className="text-gray-400">&rarr;</span>
    <span className="text-green-600">{to == null ? '-' : String(to)}</span>
  </span>
)

const fmt = (t, key, value) => {
  if (key === 'weekdays') {
    const names = t('receiving_config.franjas.weekdays_short', { returnObjects: true })
    return (value || []).map(d => names[d]).join(' ')
  }
  return value
}

const FranjaPill = ({ franja, tone }) => (
  <span className={`rounded px-2 py-0.5 text-xs ${tone === 'green' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700 line-through'}`}>
    {franja.label}
  </span>
)

export const ConfigDiff = ({ before, after }) => {
  const { t } = useTranslation()
  const diff = diffConfigs(before, after)
  if (diff.isEmpty) return <span className="text-gray-400 text-sm">{t('receiving_config.history.no_changes')}</span>

  return (
    <div className="space-y-2 text-sm">
      {diff.settings.length > 0 && (
        <div>
          <div className="font-medium text-gray-700">{t('receiving_config.history.settings')}</div>
          <ul className="ml-2">
            {diff.settings.map(s => (
              <li key={s.key} className="flex gap-2">
                <span className="text-gray-600">
                  <span>{t(`receiving_config.settings.fields.${s.key}`)}</span>:
                </span>
                <Scalar from={s.from} to={s.to} />
              </li>
            ))}
          </ul>
        </div>
      )}
      {diff.franjas.changed.length > 0 && (
        <div>
          <div className="font-medium text-gray-700">{t('receiving_config.history.franjas_changed')}</div>
          {diff.franjas.changed.map(f => (
            <div key={f.id ?? f.label} className="ml-2">
              <span className="text-gray-800">{f.label}</span>
              <ul className="ml-2">
                {f.fields.map(field => (
                  <li key={field.key} className="flex gap-2">
                    <span className="text-gray-600">
                      <span>{t(`receiving_config.franjas.modal.${field.key}`)}</span>:
                    </span>
                    <Scalar from={fmt(t, field.key, field.from)} to={fmt(t, field.key, field.to)} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
      {[
        ['added', 'green'],
        ['reactivated', 'green'],
        ['retired', 'red'],
      ].map(([group, tone]) =>
        diff.franjas[group].length > 0 ? (
          <div key={group} className="flex items-center gap-1 flex-wrap">
            <span className="font-medium text-gray-700">
              <span>{t(`receiving_config.history.franjas_${group}`)}</span>:
            </span>
            {diff.franjas[group].map(f => (
              <FranjaPill key={f.id ?? f.label} franja={f} tone={tone} />
            ))}
          </div>
        ) : null,
      )}
    </div>
  )
}
